export enum PInputSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}
